module.exports = __webpack_public_path__ + "media/images/invitations-56dde0e158f30763192885e306a79540.png";